import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Y from '../../y18n'
import * as enumActions from '../../store/enums'
import Styles from '../styles'

const mapStateToProps = state => ({
  enums: state.enums
})

const mapDispatchToProps = dispatch => ({
  enumActions: bindActionCreators(enumActions, dispatch)
})

class PageNamesDropdown extends Component {
  componentDidMount () {
    this.props.enumActions.getPageNames()
  }

  render () {
    const { enums, value, handleChange, classes } = this.props
    if (!enums.pageNames || !enums.pageNames[0]) return null
    return (
      <TextField
        select
        label={Y`Page name`}
        value={value}
        onChange={handleChange}
        SelectProps={{
          native: true
        }}
        InputProps={{
          disableUnderline: true,
          classes: {
            root: classes.root,
            input: classes.input
          }
        }}
        InputLabelProps={{
          shrink: true,
          className: classes.formLabel
        }}
        margin='normal'
        fullWidth
      >
        {value === ''
          ? <option key={'default'} value={''}>
            {Y`Choose a page name`}
          </option>
          : ''}
        {enums.pageNames.map(pageName => (
          <option key={pageName} value={pageName}>
            {Y`${pageName}`}
          </option>
        ))}
      </TextField>
    )
  }
}

PageNamesDropdown = connect(mapStateToProps, mapDispatchToProps)(PageNamesDropdown)
export default withStyles(Styles)(PageNamesDropdown)



// WEBPACK FOOTER //
// ./src/common/dropdowns/page-names-dropdown.js